<h3 class="group-header" [class.group-header--expand]="allowExpand" [ngClass]="formatLabelID(headerLabel)" i18n="i18n" (click)="toggleShowElement()">
    {{headerLabel}}
    @if (allowExpand) {
<i class="fa fa-lg" [ngClass]="showElement ? 'fa-caret-down' : 'fa-caret-right'" aria-hidden="true"></i>
}
</h3>
